import { render, staticRenderFns } from "./ReschedulePage.vue?vue&type=template&id=5bf59985&scoped=true"
import script from "./ReschedulePage.vue?vue&type=script&lang=js"
export * from "./ReschedulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf59985",
  null
  
)

export default component.exports